// Shared constants + helpers for Content tab sub-panels.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PLATFORMS = [
  'Instagram', 'Facebook', 'TikTok', 'LinkedIn',
  'Twitter/X', 'YouTube', 'Threads', 'Pinterest',
];

export const STATUSES = ['Idea', 'Planned', 'Draft', 'Ready', 'Posted'];

// Compact labels + colors for the board cards
export const PLATFORM_SHORT = {
  Instagram: 'IG',
  Facebook: 'FB',
  TikTok: 'TikTok',
  LinkedIn: 'LI',
  'Twitter/X': 'X',
  YouTube: 'YT',
  Threads: 'Threads',
  Pinterest: 'Pin',
};

export const PLATFORM_COLORS = {
  Instagram: 'bg-pink-100 text-pink-700 dark:bg-pink-900/40 dark:text-pink-300',
  Facebook: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  TikTok: 'bg-slate-900 text-white dark:bg-slate-200 dark:text-slate-900',
  LinkedIn: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
  'Twitter/X': 'bg-slate-800 text-white dark:bg-slate-300 dark:text-slate-900',
  YouTube: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  Threads: 'bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-200',
  Pinterest: 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
};

export const STATUS_COLORS = {
  Idea: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  Planned: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  Draft: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  Ready: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  Posted: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
};

export const THEME_COLORS = ['violet', 'sky', 'emerald', 'amber', 'rose', 'pink', 'orange', 'indigo'];

export const THEME_COLOR_CLASS = {
  violet: 'bg-violet-100 text-violet-700 border-violet-200',
  sky: 'bg-sky-100 text-sky-700 border-sky-200',
  emerald: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  amber: 'bg-amber-100 text-amber-700 border-amber-200',
  rose: 'bg-rose-100 text-rose-700 border-rose-200',
  pink: 'bg-pink-100 text-pink-700 border-pink-200',
  orange: 'bg-orange-100 text-orange-700 border-orange-200',
  indigo: 'bg-indigo-100 text-indigo-700 border-indigo-200',
};

export const DAYS_OF_WEEK = [
  'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday',
];

export const INSPIRATION_CATEGORIES = [
  'post', 'story', 'hook', 'quote', 'reel', 'question', 'note',
];

export const BANK_CATEGORIES = ['caption', 'post', 'hashtag', 'cta', 'template'];

export const PAGE_SIZE = 20;

// Monday of the week containing date d, local time
export const startOfWeek = (d) => {
  const dt = new Date(d);
  const day = dt.getDay(); // 0=Sun..6=Sat
  const diff = day === 0 ? -6 : 1 - day;
  dt.setDate(dt.getDate() + diff);
  dt.setHours(0, 0, 0, 0);
  return dt;
};

export const fmt = (d) => d.toISOString().split('T')[0];

export const dayLabel = (d) =>
  d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
